function updateBasketCount(lines)
{
    var parent = window.parent;
    for (var depth = 3; depth > 0; depth--) {
        if ($('#global-basket-quantity', parent.document).length) {
            $('#global-basket-quantity', parent.document).text(lines);
            $('#global-basket-quantity', parent.document).show();
            break;
        }
        parent = parent.parent;
    }
}

// Just show the loading dialog. Currently
// relies on a page reload or redirect to
// remove. Will not close on its own.
function showLoadingDialog(title)
{
    $i.dialog('partDialog',
    {
        closeable: false,
        titleKey: title,
        body: '<div id="parts-loading-icon"><img id="part-data" alt="Loading..." src="../images/loading.gif"/></div>',
        width: '550px',
        buttonKeys: {}
    });
}

function loadDialog(titleKey, bodyKey, action, basketLineId)
{
    $i.dialog('partDialog',
    {
        titleKey: titleKey,
        bodyKey: bodyKey,
        width: DIALOG_WIDTH_SMALL,
        buttonKeys:
        {
            'parts.dialog.button.cancel': function()
            {
                this.close();
            },
            'parts.dialog.button.submit': function()
            {
                $.post(action + NO_DECORATOR, {basketLineId:basketLineId}, function()
                {
                    location.reload();
                });
            }
        }
    });
}
